import { useQuery } from '@tanstack/react-query';
import { useCockpitApi } from '@/api/provider';

export function useHealth() {
  const api = useCockpitApi();
  return useQuery({
    queryKey: ['cockpit', 'health'],
    queryFn: () => api.health(),
    staleTime: 10_000,
    refetchInterval: 30_000,
  });
}
